import { render, staticRenderFns } from "./OFilterNumberField.vue?vue&type=template&id=0a14a050"
import script from "./OFilterNumberField.vue?vue&type=script&lang=js"
export * from "./OFilterNumberField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports